function gcd(a: number, b: number): number {
	while (b !== 0) {
		const t = b
		b = a % b
		a = t
	}
	return a
}

function lcm(a: number, b: number): number {
	return (a / gcd(a, b)) * b
}

export function invertTickets(
	teamTickets: { teamIndex: number; tickets: number }[]
) {
	const nonZero = teamTickets.filter((t) => t.tickets > 0)
	if (nonZero.length === 0) return teamTickets

	const totalLcm = nonZero.reduce((acc, t) => lcm(acc, t.tickets), 1)

	return teamTickets.map((t) => ({
		teamIndex: t.teamIndex,
		tickets: t.tickets > 0 ? totalLcm / t.tickets : 0
	}))
}

export const chance = (
	teamIndex: number,
	teamTickets: { teamIndex: number; tickets: number }[],
	isCrazy?: boolean
) => {
	if (!isCrazy) {
		const totalTickets = teamTickets.reduce((sum, t) => sum + t.tickets, 0)
		if (totalTickets === 0) return 1 / teamTickets.length

		return teamTickets[teamIndex].tickets / totalTickets
	}

	const inverted = invertTickets(teamTickets)
	const invertedTotal = inverted.reduce((sum, t) => sum + t.tickets, 0)

	console.info('crazy', teamIndex, inverted[teamIndex].tickets / invertedTotal)

	return inverted[teamIndex].tickets / invertedTotal
}
